export const initializeSurveyCampaign = () => ({
  type: 'INITIALIZE_SURVEY_CAMPAIGN',
});

export const fetchSurveyCampaign = resp => ({
  type: 'FETCH_SURVEY_CAMPAIGN',
  payload: resp,
});
